// @ts-nocheck
import React, { createContext, useCallback, useContext, useState } from 'react';

const RequirementContext = createContext({});

// O valor guardado em localStorage precisa ser sempre UM objeto (o
// requisito/processo selecionado). O botão de impressão do Card gravava
// um array com um item, e as páginas de procuração e de emissão de
// certidão leem `requirement.proxy_form_path` / `requirement.reference_id`
// direto — com um array no lugar, tudo vinha undefined e a página quebrava
// (e o link do Typeform de certidão saía sem os hidden fields). Normaliza
// na entrada e na leitura, pra valores antigos já gravados também.
const normalizar = (valor) => {
  if (Array.isArray(valor)) return valor[0] ?? {};
  return valor ?? {};
};

export const RequirementProvider = ({ children }) => {
  const [requirement, setRequirement] = useState(() => {
    const getRequirement = localStorage.getItem('@Central:requirement');

    if(getRequirement) {
      try {
        return normalizar(JSON.parse(getRequirement));
      } catch (e) {
        return {};
      }
    }

    return {};
  });

  const addRequirement = useCallback((object) => {
    const valor = normalizar(object);
    localStorage.setItem('@Central:requirement', JSON.stringify(valor));

    setRequirement(valor);
  }, []);

  const removeRequirement = useCallback(() => {
    localStorage.removeItem('@Central:requirement');

    setRequirement({});
  }, []);

  return (
    <RequirementContext.Provider value={{ addRequirement, removeRequirement, requirement }}>
      {children}
    </RequirementContext.Provider>
  );
}

export const useRequirement = () => {
  const context = useContext(RequirementContext);

  if(!context) {
    throw new Error('useRequirement só pode ser usado com o RequirementProvider');
  }

  return context;
}
